import React, { FunctionComponent } from 'react';

import { InputStatus } from '../helpers/getFinalFieldState.types';

import { $InputDepiction } from './Depiction.styles';
import DepictionIco from './DepictionIco';

interface DepictionProps {
  status?: InputStatus;
  name?: string;
  isSmall?: boolean;
}

const Depiction: FunctionComponent<React.PropsWithChildren<DepictionProps>> = ({
  status,
  name,
  isSmall = false,
}) => {
  if (!status) {
    return <></>;
  }

  return (
    <$InputDepiction $show $isSmall={isSmall}>
      <DepictionIco name={name} status={status} />
    </$InputDepiction>
  );
};

export default Depiction;
